import script from "./ErrorStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorStatus.vue?vue&type=script&setup=true&lang=js"

import "./ErrorStatus.vue?vue&type=style&index=0&id=351e46aa&scoped=true&lang=scss"

import exportComponent from "/root/yunxiao/be-oq3uli62ily0nz39bqi4ejzo/runner/__flow_work/__flow_builds/b53d412c-1e8a-456a-9c29-1ab66932d45e/workspace/h5s_4wZu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-351e46aa"]])

export default __exports__